// Commonality utility functions for field name generation and processing

/**
 * Converts text to snake_case format
 */
export const toSnakeCase = (str: string) => {
  return str
    .replace(/([a-z\d])([A-Z])/g, '$1_$2') // Insert underscore between lowercase/digit and uppercase
    .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2') // Handle consecutive capitals like XMLHttp -> XML_Http
    .replace(/[\s-]+/g, '_') // Replace spaces and hyphens with underscores
    .replace(/_+/g, '_') // Replace multiple underscores with single underscore
    .replace(/^_|_$/g, '') // Remove leading/trailing underscores
    .toLowerCase();
};

/**
 * Cleans channel name by removing environment suffixes and US country code
 */
export const cleanChannelName = (channelName: string) => {
  if (!channelName) return 'channel';

  let cleaned = channelName;

  // Remove environment suffixes first
  cleaned = cleaned.replace(/-?(prod|preprod|staging|dev)$/i, '');

  // Remove "us" suffix (for US channels where users don't care about country code)
  cleaned = cleaned.replace(/us$/i, '');

  // Don't convert to lowercase here - let toSnakeCase handle camelCase conversion first

  return cleaned || 'channel'; // Fallback if everything was removed
};
